import {
    GET_STATUS,
    SET_STATUS
} from "./StatusType"

const getStatus = () => ({
    type: GET_STATUS
});

const setStatus = (statusDropDown: any) => ({
    type: SET_STATUS,
    statusDropDown: statusDropDown
});

export {
    getStatus,
    setStatus
}
